import type { SettingsPreferencesProps } from './Settings.types';
import type { ReactElement } from 'react';

import { Flex, Heading } from '@rango-dev/whale';
import { Cookie, FlaskConical, Languages as LanguagesIcon, SunMedium } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Languages } from '../../constants/i18n';
import { useAppSelector } from '../../hooks/reduxHooks';
import { isAnyFeatureAvailableOnMode } from '../../utils/generalFunctions/getExperimentals';

import styles from './Settings.module.css';
import { SettingsRow } from './Settings.Row';
import { useThemeOptions } from './Settings.Theme';

const ROW_ICON_SIZE = 20;

export function SettingsPreferences(props: SettingsPreferencesProps): ReactElement {
  const { t } = useTranslation();
  const { language, theme } = useAppSelector((state) => state.settings);
  const themeOptions = useThemeOptions();

  const themeTitle = themeOptions.find((option) => option.value === theme)?.title;
  const languageTitle = Languages.find((item) => item.value === (language || 'en'))?.title;

  return (
    <Flex direction="column" gap="4">
      <Heading as="h2" size="3" weight="bold" align="left" className={styles.heading}>
        {t('Preferences')}
      </Heading>
      <Flex direction="column" gap="2">
        <SettingsRow
          id="header-settings-theme-item"
          icon={<SunMedium size={ROW_ICON_SIZE} />}
          label={t('Theme')}
          value={themeTitle}
          onClick={() => props.onSelect('theme')}
        />
        <SettingsRow
          id="header-settings-language-item"
          icon={<LanguagesIcon size={ROW_ICON_SIZE} />}
          label={t('Language')}
          value={languageTitle}
          onClick={() => props.onSelect('language')}
        />
        {isAnyFeatureAvailableOnMode() && (
          <SettingsRow
            id="header-settings-experimental-features-item"
            icon={<FlaskConical size={ROW_ICON_SIZE} />}
            label={t('Experimental Features')}
            onClick={() => props.onSelect('experimental')}
          />
        )}
        <SettingsRow
          id="header-settings-cookie-item"
          className="cky-banner-element"
          icon={<Cookie size={ROW_ICON_SIZE} />}
          label={t('Cookie preferences')}
          hasChevron={false}
        />
      </Flex>
    </Flex>
  );
}
